import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { Box, CircularProgress, Hidden, Typography } from "@material-ui/core";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { buttonColors } from "../../../../utils/enum";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import { createIntegrationConfig } from "../../../../services/locationApp/integrationsService";

export interface IntegrationRedirectProps {}

/* HubRise sends the user back here after the OAuth screen. This page reads the
   code from the query string, sends it to the backend so the integration can be
   stored, and then returns the user to the integrations list. */
const IntegrationRedirect: React.FunctionComponent<
  IntegrationRedirectProps
> = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const match: any = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const locationId = (match.params as any).locationId;

  const integrationsPath = `/${locationId}/presto-locations/integrations`;

  const saveHubriseIntegration = async () => {
    console.log("saveHubriseIntegration called")
    const params = new URLSearchParams(location.search);
        console.log("saveHubriseIntegration called 1111111")
    const code = params.get("code");
        console.log("saveHubriseIntegration called 2222")
    if (!code) {
              console.log("saveHubriseIntegration called 3333")
      setError("HubRise did not send an authorization code.");
      setIsLoading(false);
      return;
    }
        console.log("saveHubriseIntegration called 44444")
    // The backend expects the HubRise authorization code as `auth_code`.
    const data: any = { auth_code: code };
        console.log("saveHubriseIntegration called 6666", data)
    try {
              console.log("saveHubriseIntegration called 55555")
      const response = await createIntegrationConfig(locationId, data);
              console.log("saveHubriseIntegration called 77777", response)
      // The api can answer with http 200 while the body carries its own error
      // status (for example { status: 404, message: "No integration record is
      // available in Integration" }), so both statuses are checked.
      const bodyStatus = response?.data?.status;
      const isSaved =
        (response.status === 200 || response.status === 201) &&
        (!bodyStatus || bodyStatus === 200 || bodyStatus === 201);

      if (isSaved) {
        // Saved — send the user back to the integrations list, using replace so
        // the browser back button does not return to this callback url.
        history.replace(integrationsPath);
        return;
      }
      setError(response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    } catch (err) {
       console.log("saveHubriseIntegration called 8888", err)
      setError(
        (err as any)?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR,
      );
      setIsLoading(false);
    }
  };

  useEffect(() => {
    saveHubriseIntegration();
  }, []);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: "60vh", gap: "16px" }}
      >
        {isLoading ? (
          <>
            <CircularProgress />
            <Typography variant="body2" color="textSecondary">
              Connecting HubRise, please wait…
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body2" color="textSecondary">
              We could not complete the HubRise connection.
            </Typography>
            <ButtonCommon
              onClick={() => history.replace(integrationsPath)}
              variant="contained"
              style={{ fontSize: 11, width: "180px" }}
              color={buttonColors.CREATE_BUTTON_COLOR}
            >
              {"Back to Integrations"}
            </ButtonCommon>
          </>
        )}
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(IntegrationRedirect, Authorities.BASIC_INFO_READ);